import style from "../rodingenerateboard.module.css";
import Lock from "../assets/lock.png";

const LockTip = ({ status, message }) => {
    if (status) {
        return null
    }
    return (
        <div className={style.simplelockTitle}>
            <img src={Lock} alt='lock.png' />
            <span>{`${window.innerHeight < 700 ? "Locked" : message}`}</span>
        </div>
    )
}

export {LockTip}